import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DateRangeComponent } from '../../common/date-range/date-range.component';
import { FloatLabel } from 'primeng/floatlabel';
import { InputText } from 'primeng/inputtext';
import { Textarea } from 'primeng/textarea';
import { NgClass } from '@angular/common';
import { Button } from 'primeng/button';
import { EhrenamtFormGroup } from '../bewerbung-einreichen/bewerbung-einreichen-form-groups';
import { TrimInputValueDirective } from '../../../services/form/trim-input-value.directive';
import { Fieldset } from 'primeng/fieldset';

export const TAETIGKEIT_MAX_LENGTH: number = 500;

@Component({
  selector: 'app-ehrenamt[ehrenamtForm]',
  templateUrl: './ehrenamt.component.html',
  styleUrls: ['./ehrenamt.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ReactiveFormsModule, DateRangeComponent, FloatLabel, InputText, Textarea, NgClass, Button, TrimInputValueDirective, Fieldset],
  standalone: true
})
export class EhrenamtComponent {
  @Input()
  public ehrenamtForm!: FormGroup<EhrenamtFormGroup>;

  @Output()
  public remove: EventEmitter<void> = new EventEmitter<void>();
  public constructor() {}

  protected get taetigkeitCount(): number {
    return this.ehrenamtForm.controls.taetigkeit.value?.length ?? 0;
  }

  protected get taetigkeitMaxLength(): number {
    return TAETIGKEIT_MAX_LENGTH;
  }
}
